import { IDirectoryRecordOwner, IOwnersActionTypes } from "./types";

export type OwnersAction =
    | {
          type: IOwnersActionTypes.GET_OWNERS;
          payload: IDirectoryRecordOwner[];
      }
    | {
          type: IOwnersActionTypes.GET_OWNERS_LOADING;
          payload: boolean;
      };

export const getDirectoryOwnersLoading = (payload: boolean): OwnersAction => ({
    type: IOwnersActionTypes.GET_OWNERS_LOADING,
    payload,
});
